import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AuditBundle } from '../types/org.types';

type OrgIdentity = {
  orgUrl: string | null;
  orgName: string | null;
  edition: string | null;
  username: string | null;
  role?: 'consultant' | 'client-admin';
};

type OrgState = OrgIdentity & {
  audit: AuditBundle;
  setIdentity: (next: Partial<OrgIdentity>) => void;
  setAudit: (audit: AuditBundle) => void;
  reset: () => void;
};

const empty: OrgIdentity = {
  orgUrl: null,
  orgName: null,
  edition: null,
  username: null,
};

export const useOrgStore = create<OrgState>()(
  persist(
    (set) => ({
      ...empty,
      audit: {},
      setIdentity: (next) => set((s) => ({ ...s, ...next })),
      setAudit: (audit) => set({ audit }),
      reset: () => set({ ...empty, audit: {} }),
    }),
    {
      name: 'orgiq.org',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
